import { __ } from "@wordpress/i18n";
import { useSettingsContext } from "../../../../hook/useSettingsContext";
import { useSpacingObject } from "../../../../hook/useSpacingObject";
import SettingsForm from "../../SettingsForm";
import Wrapper from "../../../../components/UI/common/Wrapper";
import FieldWrapper from "../../../../components/UI/common/FieldWrapper";
import ColorPicker from "../../../../components/UI/ColorPicker";
import Select from "../../../../components/UI/Select";
import SpaceControl from "../../../../components/UI/SpaceControl";
import NumberUnit from "../../../../components/UI/NumberUnit";

export default function InputSettings() {
    const {
        settings,
        getSection,
        getOption,
        handleInputChange,
        handleSpaceControlChange,
    } = useSettingsContext();

    const sectionID = "input";
    const section = getSection(sectionID);

    //console.log(settings);
    // console.log(getOption("qtyPadding", sectionID));
    // console.log(useSpacingObject(getOption("qtyPadding", sectionID)));

    //const qtyPadding = getOption("qtyPadding", sectionID);
    const qtyPadding = useSpacingObject(getOption("qtyPadding", sectionID));
    const qtyMargin = useSpacingObject(getOption("qtyMargin", sectionID));

    return (
        <SettingsForm
            title={__(
                "Qty Input Settings",
                "wpbean-quantity-controls-for-woocommerce",
            )}
            subtitle={__(
                "Customize quantity input style here.",
                "wpbean-quantity-controls-for-woocommerce",
            )}
        >
            <Wrapper
                title={__(
                    "Size Customization",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "The quantity input size can be adjusted here.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
            >
                <>
                    <FieldWrapper
                        label={__(
                            "Width",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "The quantity input width.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        type="number-unit"
                        width="30"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <NumberUnit
                            value={getOption("qtyWidth", sectionID)}
                            onChange={(value) =>
                                handleInputChange(section, "qtyWidth", value)
                            }
                        />
                    </FieldWrapper>
                    <FieldWrapper
                        label={__(
                            "Height",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "The quantity input height.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        type="number-unit"
                        width="30"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <NumberUnit
                            value={getOption("qtyHeight", sectionID)}
                            onChange={(value) =>
                                handleInputChange(section, "qtyHeight", value)
                            }
                        />
                    </FieldWrapper>
                </>
            </Wrapper>
            <Wrapper
                title={__(
                    "Text Color Options",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Quantity buttons text color settings.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
            >
                <>
                    <FieldWrapper
                        label={__(
                            "Color",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "The quantity input text color.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="49"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <ColorPicker
                            name="qtyColor"
                            value={getOption("qtyColor", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                        />
                    </FieldWrapper>
                    <FieldWrapper
                        label={__(
                            "Hover Color",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "The quantity input text hover color.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="49"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <ColorPicker
                            name="qtyHoverColor"
                            value={getOption("qtyHoverColor", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                        />
                    </FieldWrapper>
                </>
            </Wrapper>
            <Wrapper
                title={__(
                    "Background Options",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Quantity buttons background color settings.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
            >
                <>
                    <FieldWrapper
                        label={__(
                            "Background",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "Choose the background color for the quote button.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="49"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <ColorPicker
                            name="btnBgColor"
                            value={getOption("btnBgColor", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                        />
                    </FieldWrapper>

                    <FieldWrapper
                        label={__(
                            "Hover Background",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "Choose quote button hover background color.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="49"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <ColorPicker
                            name="btnBgHoverColor"
                            value={getOption("btnBgHoverColor", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                        />
                    </FieldWrapper>
                </>
            </Wrapper>

            <Wrapper
                title={__(
                    "Border Options",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Quantity buttons border settings.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
            >
                <>
                    <FieldWrapper
                        label={__(
                            "Width",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "The quantity button border width can be adjusted here.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        type="number-unit"
                        width="30"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <NumberUnit
                            value={getOption("borderWidth", sectionID)}
                            onChange={(value) =>
                                handleInputChange(section, "borderWidth", value)
                            }
                        />
                    </FieldWrapper>
                    <FieldWrapper
                        label={__(
                            "Radius",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "The quantity button border radius can be adjusted here.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        type="number-unit"
                        width="30"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <NumberUnit
                            value={getOption("borderRadius", sectionID)}
                            onChange={(value) =>
                                handleInputChange(
                                    section,
                                    "borderRadius",
                                    value,
                                )
                            }
                        />
                    </FieldWrapper>
                    <FieldWrapper
                        label={__(
                            "Color",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "Choose the border color for the quantity buttons.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="49"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <ColorPicker
                            name="borderColor"
                            value={getOption("borderColor", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                        />
                    </FieldWrapper>
                    <FieldWrapper
                        label={__(
                            "Hover Color",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "Choose the hover border color for the quantity buttons.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="49"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <ColorPicker
                            name="borderHoverColor"
                            value={getOption("borderHoverColor", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                        />
                    </FieldWrapper>
                </>
            </Wrapper>

            <Wrapper
                title={__(
                    "Typography Options",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "You can adjust the quantity input typography here.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
            >
                <>
                    <FieldWrapper
                        label={__(
                            "Font Size",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "Quantity input font size, Can be in any CSS unit.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        type="number-unit"
                        width="30"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <NumberUnit
                            value={getOption("qtyFontSize", sectionID)}
                            onChange={(value) =>
                                handleInputChange(section, "qtyFontSize", value)
                            }
                        />
                    </FieldWrapper>

                    <FieldWrapper
                        label={__(
                            "Font Weight",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        help={__(
                            "Quantity input font weight.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="36"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <Select
                            placeholder={__(
                                "Select an option",
                                "wpbean-quantity-controls-for-woocommerce",
                            )}
                            name="qtyFontWeight"
                            value={getOption("qtyFontWeight", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                            options={[
                                {
                                    value: "100",
                                    label: __(
                                        "100",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                                {
                                    value: "200",
                                    label: __(
                                        "200",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                                {
                                    value: "300",
                                    label: __(
                                        "300",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                                {
                                    value: "400",
                                    label: __(
                                        "400",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                                {
                                    value: "500",
                                    label: __(
                                        "500",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                                {
                                    value: "600",
                                    label: __(
                                        "600",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                                {
                                    value: "700",
                                    label: __(
                                        "700",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                                {
                                    value: "800",
                                    label: __(
                                        "800",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                                {
                                    value: "900",
                                    label: __(
                                        "900",
                                        "wpbean-quantity-controls-for-woocommerce",
                                    ),
                                },
                            ]}
                        />
                    </FieldWrapper>
                </>
            </Wrapper>

            <div className="rounded-lg border border-gray-100 p-4">
                <FieldWrapper
                    label={__(
                        "Padding",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    description={__(
                        "You can adjust the quantity padding here.",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    type="box-control"
                    width="100"
                    containerClass="grid grid-cols-1 lg:grid-cols-2 lg:items-center lg:gap-10 gap-4"
                >
                    <SpaceControl
                        value={qtyPadding}
                        onChange={(values) =>
                            handleSpaceControlChange(
                                values,
                                section,
                                "qtyPadding",
                            )
                        }
                    />
                </FieldWrapper>
            </div>

            <div className="rounded-lg border border-gray-100 p-4">
                <FieldWrapper
                    label={__(
                        "Margin",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    description={__(
                        "You can adjust the quantity margin here.",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    type="box-control"
                    width="100"
                    containerClass="grid grid-cols-1 lg:grid-cols-2 lg:items-center lg:gap-10 gap-4"
                >
                    <SpaceControl
                        value={qtyMargin}
                        onChange={(values) =>
                            handleSpaceControlChange(
                                values,
                                section,
                                "qtyMargin",
                            )
                        }
                    />
                </FieldWrapper>
            </div>
        </SettingsForm>
    );
}
